<template>
  <div>
    <div class="w-full flex justify-between items-start">
      <Lynx-Title
        :text="
          tipo_planilha
            ? 'Acompanhamento dos Alvarás'
            : 'Acompanhamento de Taxas'
        "
      />
      <Lynx-Button
        v-if="!tipo_planilha && hasRole('admin')"
        text="Relatorio Taxa"
        class=""
        style="margin-top: 10px"
        @click.native="gerarRelatorio('taxa')"
        size="small"
        icon-size="3"
      />
      <Lynx-Button
        v-if="tipo_planilha && hasRole('admin')"
        text="Relatorio Alvara"
        class=""
        style="margin-top: 10px"
        @click.native="gerarRelatorio('alvara')"
        size="small"
        icon-size="3"
      />
    </div>

    <v-row class="justify-between">
      <v-col cols="12" md="3" sm="6" lg="3">
        <v-btn
          :disabled="loading"
          color="#031127"
          style="border-radius: 25px"
          small
          :dark="!loading"
          @click.native="fetchEmpresaAlvaraTaxasVencidas"
        >
          {{
            !buscouVencidas ? "Buscar taxas vencidas" : "Buscar tabela completa"
          }}
          <v-icon v-if="!loading">mdi-refresh</v-icon>
          <v-progress-circular
            v-else
            indeterminate
            color="white"
            size="24"
            class="ml-2"
          ></v-progress-circular>
        </v-btn>
      </v-col>
      <v-col
        cols="12"
        md="3"
        sm="6"
        lg="3"
        class="row align-center justify-end"
      >
        <v-btn
          :disabled="loading"
          color="#031127"
          style="border-radius: 25px"
          small
          :dark="!loading"
          @click.native="fetchEmpresasAlvarasTaxa"
        >
          Atualizar Planilha
          <v-icon v-if="!loading">mdi-refresh</v-icon>
          <v-progress-circular
            v-else
            indeterminate
            color="white"
            size="24"
            class="ml-2"
          ></v-progress-circular>
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-row>
          <v-col cols="12" md="3">
            <label class="flex flex-col">
              <Lynx-Label label="Seleciona um período" />
              <b-datepicker
                v-model="filtros.data"
                placeholder="Seleciona um período"
                :date-parser="(date) => new Date(date)"
                :month-names="monthNames"
                :day-names="dayNames"
                :years-range="[-3, 3]"
                range
              >
                <b-button
                  label="Clear"
                  type="is-danger"
                  icon-left="close"
                  outlined
                  @click="filtros.data = null"
                />
              </b-datepicker>
            </label>
          </v-col>
          <v-col cols="12" md="3" v-if="tipo_planilha">
            <label class="flex flex-col">
              <Lynx-Label label="Status Alvara" />
              <treeselect
                :multiple="false"
                :options="
                  this.lista_status.filter(
                    (status) =>
                      (status.id === 'definitivo' &&
                        filtros.tipo_alvara == 'alvara') ||
                      filtros.tipo_alvara == 'alvara' ||
                      (status.id != 'definitivo' &&
                        filtros.tipo_alvara != 'alvara')
                  )
                "
                placeholder="Selecione o status do Alvara"
                v-model="filtros.status_alvara"
              />
            </label>
          </v-col>
          <v-col cols="12" md="3" v-if="!tipo_planilha">
            <label class="flex flex-col">
              <Lynx-Label label="Status Taxa" />
              <treeselect
                :multiple="false"
                :options="lista_status"
                placeholder="Selecione o status da Taxa"
                v-model="filtros.status_taxa"
              />
            </label>
          </v-col>
          <v-col cols="12" md="3" v-if="tipo_planilha">
            <label class="flex flex-col">
              <Lynx-Label label="Tipo Alvara" />
              <treeselect
                :multiple="false"
                :options="lista_tipo_alvara"
                v-model="filtros.tipo_alvara"
                placeholder="Selecione tipo do Alvara"
              />
            </label>
          </v-col>
          <v-col cols="12" md="3" v-else>
            <label class="flex flex-col">
              <Lynx-Label label="Tipo Alvara" />
              <treeselect
                :multiple="false"
                :options="lista_tipo_alvara_taxas"
                v-model="filtros.tipo_alvara"
                placeholder="Selecione tipo do Alvara"
              />
            </label>
          </v-col>
          <v-col cols="12" md="3">
            <label>
              <Lynx-Label label="Carteiras" class=" " />
              <treeselect
                :multiple="true"
                :options="lista_carteiras"
                placeholder="Selecione a(s) carteiras(s)"
                v-model="filtros.carteira_filter"
              />
            </label>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="2">
            <label>
              <Lynx-Label label="ID Empresas" class=" " />
              <input
                class="border-primary-200 bg-white px-2 border-l-4 border-solid rounded py-1 w-full transition focus:shadow focus:border-r-4 font-light"
                v-model="empresas_id"
                v-on:keyup.enter="fetchEmpresasAlvarasTaxa"
              />
            </label>
          </v-col>
          <v-col cols="12" md="3">
            <label>
              <Lynx-Label label="Cidades" class=" " />
              <v-autocomplete
                :loading="loadingCidades"
                v-model="filtros.cidades"
                :items="lista_cidades"
                :search-input.sync="searchQuery"
                label="Selecione a(s) cidades(s)"
                multiple
                dense
                item-text="nome"
                item-value="id"
                @change="clearSearchQuery"
              >
              </v-autocomplete>
            </label>
          </v-col>
          <v-col cols="12" md="2">
            <label>
              <Lynx-Label label="Status de envio" class=" " />
              <treeselect
                :multiple="false"
                :options="[
                  { id: 1, label: 'Enviado' },
                  { id: 2, label: 'Não enviado' },
                ]"
                placeholder="Selecione status de envio"
                v-model="filtros.status_envio_taxa"
              />
            </label>
          </v-col>
          <v-col cols="12" md="3">
            <label>
              <Lynx-Label label="Status Taxas Preenchidas" class=" " />
              <treeselect
                :multiple="false"
                :options="[
                  { id: 1, label: 'Sem preenchimento, campo vazio' },
                  { id: 2, label: 'Precisa preencher a próxima taxa' },
                ]"
                placeholder="Selecione Status de Taxas"
                v-model="filtros.sem_taxa"
              />
            </label>
          </v-col>
          <v-col cols="12" md="2">
            <label>
              <Lynx-Label label="Itens por página" />
              <b-select v-model="filtros.perPage">
                <option
                  :value="perPageOption"
                  v-for="perPageOption in perPageOptions"
                  :key="perPageOption"
                >
                  {{ perPageOption }}
                </option>
              </b-select>
            </label>
          </v-col>
        </v-row>

        <v-row class="justify-end">
          <v-col cols="12" md="6">
            <v-row>
              <v-col cols="12" md="4">
                <label>
                  <Lynx-Label label="Tem taxa na viabilidade" />
                  <b-switch
                    v-model="filtros.tem_taxa_viabilidade"
                    true-value="1"
                    false-value="0"
                  />
                </label>
              </v-col>
              <v-col cols="12" md="8">
                <label>
                  <Lynx-Label
                    label="Sem data preenchida na taxa da viabilidade"
                  />
                  <b-switch
                    v-model="filtros.sem_viabiliade_taxa_data_cadastrada"
                    true-value="1"
                    :false-value="null"
                  />
                </label>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" md="6" class="d-flex justify-end">
            <span v-if="pagination && !loading" class="text-xl">
              Quantidade de Empresas: {{ pagination.total }}
            </span>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="12" lg="12">
        <div class="table-container">
          <b-table
            class="table"
            :data="loading ? [] : empresasAlvarasTaxas"
            :columns="colunas"
            hoverables
            paginated
            default-sort-direction="asc"
            default-sort="id"
            :loading="loading"
            backend-pagination
            @page-change="onPageChange"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page"
            :total="pagination.total"
            :current-page="pagination.current_page"
            :per-page="pagination.per_page"
            striped
            style="font-size: smaller"
            :style="tamanhoTela"
            detailed
            detail-key="id"
            :detail-transition="transitionName"
            :opened-detailed="defaultOpenedDetails"
            @details-open="(row, index) => fecharTodos(row, index)"
          >
            <template slot-scope="props">
              <b-table-column
                field="id"
                style="
                  width: 30px;
                  position: sticky;
                  left: 0;
                  background-color: #fff;
                  z-index: 1;
                  background-color: #031127;
                  color: white;
                "
              >
                {{ props.row.id }}
              </b-table-column>
              <b-table-column
                field="cnpj"
                style="
                  width: 90px;
                  position: sticky;
                  left: 100px;
                  background-color: #fff;
                  z-index: 2;
                  background-color: #031127;
                  color: white;
                "
              >
                {{ props.row.cnpj }}
              </b-table-column>
              <b-table-column field="razao_social" style="width: 220px">
                {{ props.row.razao_social }}
              </b-table-column>
              <b-table-column field="data_inicio" style="width: 120px">
                {{ props.row.data_inicio | formatEnToBr }}</b-table-column
              >
              <b-table-column style="width: 120px" field="carteiras">
                {{ props.row.carteiras }}
              </b-table-column>
              <b-table-column
                field="alvaras"
                style="width: 200px"
                v-if="tipo_planilha"
              >
                <span v-if="hasNoAlvaras(props.row)">
                  <div
                    class="bg-primary-600 text-neutral-100 pl-2"
                    style="border-radius: 10px"
                  >
                    Nenhum alvará encontrado.
                  </div>
                </span>
                <span
                  v-else
                  v-for="(alvara, index) in [
                    ...(props.row.alvara ? [props.row.alvara] : []),
                    ...(props.row.bombeiro ? [props.row.bombeiro] : []),
                    ...(props.row.ambiental ? [props.row.ambiental] : []),
                    ...(props.row.alvara_sanitario
                      ? [props.row.alvara_sanitario]
                      : []),
                  ]"
                  :key="index"
                >
                  <div :class="getStatusClass(alvara)">
                    {{ getStatus(alvara) }}: {{ alvara.tipo_document }}
                    <span
                      v-if="
                        !alvara.definitivo ? true : alvara.definitivo == null
                      "
                    >
                      {{ alvara.data_vencimento | formatEnToBr }}</span
                    >
                  </div>
                </span>
              </b-table-column>
              <b-table-column
                style="width: 200px"
                field="taxas"
                v-if="!tipo_planilha"
              >
                <span v-if="hasNoTaxas(props.row)">
                  <div
                    class="bg-primary-600 text-neutral-100 pl-2"
                    style="border-radius: 10px"
                  >
                    Nenhuma taxa encontrada.
                  </div>
                </span>
                <span
                  v-else
                  v-for="(taxa, index) in props.row.taxas"
                  :key="index"
                  class="yellow-text"
                >
                  <div :class="getStatusClass(taxa)">
                    {{ getStatus(taxa) }}: {{ taxa.type_document }} -
                    {{ taxa.data_vencimento | formatEnToBr }}
                  </div>
                </span>
              </b-table-column>
              <b-table-column style="width: 80px" field="endereco.uf">
                <span v-if="props.row.endereco">
                  {{ props.row.endereco.uf }}
                </span>
                <span v-if="props.row.endereco">
                  {{ props.row.endereco.cidade }}
                </span>
              </b-table-column>
              <b-table-column
                v-if="!tipo_planilha"
                style="width: 120px"
                field="atualizacao"
              >
                <v-btn
                  v-if="props.row.check_alvara_taxa == null"
                  small
                  @click="showModalCheckAlvaraTaxa(props.row)"
                  color="primary"
                >
                  Fazer Check
                </v-btn>
                <div class="flex gap-5" v-else>
                  <v-icon icon elevation="2" large color="success"
                    >mdi-check</v-icon
                  >
                  <v-btn
                    @click="showModalCheckAlvaraTaxa(props.row)"
                    fab
                    dark
                    small
                    color="primary"
                  >
                    <v-icon icon elevation="2">mdi-eye</v-icon>
                  </v-btn>
                </div>
              </b-table-column>
              <b-table-column
                v-if="!tipo_planilha"
                style="width: 120px"
                field="atualizacao"
              >
                <span v-if="props.row.taxas[0]">
                  {{
                    props.row.taxas[props.row.taxas.length - 1].updated_at
                      | formatEnToBr
                  }}
                </span>
                <span v-else> sem data </span>
              </b-table-column>

              <b-table-column
                v-if="!tipo_planilha"
                field="certidao_negativa"
                style="width: 150px"
              >
                <!-- <v-btn
                @click="showModalCertidaoNegativa(props.row)"
                dark
                small
                color="primary"
                >
                Upload CND Municipal
                <v-icon class="ml-1" icon elevation="2">mdi-upload</v-icon>
                </v-btn> -->
                <UploadCertidaoNegativaMunicipal
                  :empresa="props.row"
                  @fetchEmpresasAlvarasTaxa="fetchEmpresasAlvarasTaxa"
                />
              </b-table-column>
              <b-table-column
                v-if="!tipo_planilha"
                field="viabilidade"
                style="width: 150px"
              >
                <v-btn
                  v-if="props.row.viabilidade != null"
                  @click="showModalViabilidade(props.row)"
                  fab
                  dark
                  small
                  :color="getColorViabilidade(props.row)"
                >
                  <v-icon icon elevation="2">mdi-eye</v-icon>
                </v-btn>
                <span
                  v-else
                  class="bg-error-base py-1 px-2 text-neutral-100 text-xs rounded"
                >
                  Sem taxa na viabilidade
                </span>
              </b-table-column>
              <b-table-column
                v-if="!tipo_planilha"
                field="status"
                style="width: 150px"
              >
                <b-tag :type="getTagType(props.row.status_envio_taxa)">
                  {{
                    props.row.status_envio_taxa == 1 ? "Enviado" : "Não enviado"
                  }}
                </b-tag>
              </b-table-column>

           

              <b-table-column
                v-if="tipo_planilha"
                style="width: 100px"
                field="acoes"
              >
                <div class="flex text-sm items-center">
                  <v-btn
                    icon
                    v-if="tipo_planilha"
                    class="mr-4 bg-primary-600 rounded-full p-2"
                    @click.prevent="openEditModal(props.row)"
                  >
                    <Icon-Edit class="text-neutral-100" size="4" />
                  </v-btn>
                </div>
              </b-table-column>
            </template>
            <template slot="detail" slot-scope="props">
              <EmpresaTaxa
                @listarTaxas="fetchEmpresasAlvarasTaxa"
                :empresaId="props.row.id"
                :listaUsuarios="lista_usuarios"
              />
            </template>
            <template v-slot:empty>
              <NotFoundData text="Nenhum dado encontrado!" />
            </template>
          </b-table>
          <div class="float-left" style="margin-top: -60px" v-if="!loading">
            <b-pagination
              :total="pagination.total"
              :current.sync="current_page"
              :per-page="pagination.per_page"
            />
          </div>
        </div>
      </v-col>
    </v-row>
    <b-modal :active.sync="editModal" v-if="editModal" width="500px">
      <v-card class="p-3">
        <Alvaras class="mt-4" />
      </v-card>
    </b-modal>
    <b-modal :active.sync="createModal" v-if="createModal" width="500px">
      <Create-Taxa @create-taxa="onCreateTaxa" />
    </b-modal>

    <b-modal
      :active.sync="modalCheckAlvaraTaxa"
      v-if="modalCheckAlvaraTaxa"
      width="700px"
    >
      <v-card :loading="loading" elevation="4" class="p-2">
        <Lynx-Title
          v-if="!checkAlvaraTaxa"
          text="Fez a verificação devida da taxa?"
        />
        <Lynx-Title v-else text="Observação da verificação da taxa!" />
        <div class="flex">
          <label class="w-full">
            <Lynx-Label label="Motivo" />
            <Lynx-Textarea
              :disabled="checkAlvaraTaxa"
              placeholder="Insira o motivo da checkgem"
              v-model.trim="formCheck.motivo"
            />
          </label>
        </div>
        <div v-if="!checkAlvaraTaxa" class="flex justify-end">
          <v-btn
            class="mt-2"
            small
            @click.native="criarCheckAlvaraTaxa()"
            color="#031127"
            dark
          >
            Salvar
          </v-btn>
        </div>
      </v-card>
    </b-modal>
    <b-modal
      :active.sync="modalViabilidade"
      v-if="modalViabilidade"
      width="500px"
    >
      <v-card class="p-3">
        <CardTaxasViabilidade :taxas="taxas" :viabilidade="viabilidade" />
      </v-card>
    </b-modal>
  </div>
</template>

<script>
import { usersRequest } from "@/services/requests/users";
import CardTaxasViabilidade from "@/views/viabilidade/CardTaxasViabilidade.vue";
import {
  indexEmpresasAlvarasRequest,
  criarCheckAlvaraTaxaRequest,
  // destroyEmpresasAlvarasRequest,
} from "@/services/requests/taxas";
// import EditTaxa from "@/views/empresas/taxasAlvaras/Edit";
// import CreateTaxa from "@/views/empresas/taxasAlvaras/Create";
import NotFoundData from "@/components/layouts/NotFoundData";
import moment from "moment";
import { monthNames, dayNames } from "@/utils/utils";
import { formatEnToBr, formatBrToEn } from "@/utils/momentHelpers";
import EmpresaTaxa from "@/views/empresas/taxasAlvaras/EmpresaTaxaDetail";
import Treeselect from "@riophae/vue-treeselect";
import Alvaras from "@/views/empresas/show/Alvaras";
import { mapGetters } from "vuex";
import { showCidadesRequest } from "@/services/requests/estados";
import { hasRole } from "@/utils/can";
import LynxTextarea from "@/components/helpers/Textarea";
import UploadCertidaoNegativaMunicipal from "@/views/empresas/taxasAlvaras/uploadCertidaoNegativaMunicipal";

export default {
  name: "EmpresasAlvarasIndex",
  components: {
    NotFoundData,
    Treeselect,
    Alvaras,
    EmpresaTaxa,
    LynxTextarea,
    CardTaxasViabilidade,
    UploadCertidaoNegativaMunicipal,
  },
  data() {
    return {
      monthNames,
      dayNames,
      moment,
      loading: false,
      loadingCidades: false,
      createModal: false,
      editModal: false,
      empresasAlvaras: {
        pagination: {
          current_page: 1,
          total_pages: 1,
          per_page: 10,
          total: 1,
        },
        data: [],
      },
      currentEmpAlvs: null,
      carteira: null,
      carteiras: [],
      status_alvara: null,
      status_taxa: null,
      tipo_alvara: null,
      lista_usuarios: [],
      lista_status: [
        { id: "todos", label: "todos" },
        { id: "definitivo", label: "Definitivo" },
        { id: "prox_venc", label: "Prox venc" },
        { id: "normal", label: "Normal" },
        { id: "vencido", label: "Vencido" },
      ],
      lista_tipo_alvara: [
        { id: "todos", label: "todos" },

        { id: "alvara", label: "Alvara" },
        { id: "bombeiro", label: "Bombeiro" },
        { id: "alvara_sanitario", label: "Sanitario" },
        { id: "ambiental", label: "Ambiental" },
      ],
      lista_tipo_alvara_taxas: [
        { id: "todos", label: "todos" },

        { id: "alvara", label: "Alvara" },
        { id: "bombeiro", label: "Bombeiro" },
        { id: "sanitario", label: "Sanitario" },
        { id: "ambiental", label: "Ambiental" },
      ],
      empresas_id: null,
      filtros: {
        page: 1,
        empresas_id: null,
        perPage: 10,
        status: null,
        data: null,
        status_alvara: null,
        status_taxa: null,
        tipo_alvara: null,
        tipo_planilha: null,
        carteira_filter: [],
        cidades: [],
        status_envio_taxa: null,
        sem_taxa: null,
        tem_taxa_viabilidade: null,
        sem_viabiliade_taxa_data_cadastrada: null,
      },
      perPageOptions: [10, 50, 100],
      defaultOpenedDetails: [],
      taxas: [],
      lista_cidades: [],
      formCheck: {
        motivo: null,
        empresa_id: null,
      },
      current_page: 1,
      empresas_id: null,
      loadingInicial: false,
      searchQuery: null,
      modalCheckAlvaraTaxa: false,
      checkAlvaraTaxa: null,
      modalViabilidade: false,
      viabilidade: null,
      buscouVencidas: false,
    };
  },

  filters: {
    formatEnToBr,
    statusType: (val) => {
      if (val.status === "normal") {
        return "is-success";
      }

      if (val.status === "vencido") {
        return "is-danger";
      }
      if (val.status === "prox venc") {
        return "is-warning";
      }
      if (val.status === "definitivo") {
        return "is-primary";
      }
      return "default";
    },
  },
  computed: {
    ...mapGetters(["getToken"]),

    tipo_planilha() {
      let router = this.$route.name;
      return router == "empresas.alvara-taxas.index";
    },
    lista_carteiras() {
      //  return this.$store.state.carteira.lista_carteiras;

      let carteira = Object.values(this.$store.state.carteira.lista_carteiras);
      let data = [];
      // data.push({ id: 'todas', label: 'todas',disabled:true });

      for (let i = 0; i < carteira.length; i++) {
        if (carteira[i].setor == "contabilidade") {
          data.push({ id: carteira[i].nome, label: carteira[i].nome });
        }
      }
      for (let i = 0; i < carteira.length; i++) {
        if (
          carteira[i].setor == "onboarding" &&
          carteira[i].nome != "Onboarding"
        ) {
          data.push({ id: carteira[i].nome, label: carteira[i].nome });
        }
      }
      return data;
    },

    colunas() {
      // Estrutura básica dos campos comuns
      let columns = [
        { field: "id", label: "ID" },
        { field: "cnpj", label: "CNPJ" },
        { field: "razao_social", label: "Empresa" },
        { field: "data_inicio", label: "Data inicio" },
        { field: "carteiras", label: "Carteiras" },
        { field: "endereco.uf", label: "Estado/Cidade" },
      ];

      if (!this.tipo_planilha) {
        columns.splice(5, 0, { field: "taxas", label: "Vencimento Taxas" });
        columns.splice(7, 0, { field: "check_alvara_taxas", label: "Check" });
        columns.splice(8, 0, {
          field: "atualizacao",
          label: "Ultima atualização",
        });
        columns.splice(9, 0, {
          field: "certidao_negativa",
          label: "Certidão negativa municipal",
        });
        columns.splice(10, 0, { field: "viabilidade", label: "Viabilidade" });
        columns.splice(11, 0, { field: "status", label: "status" });
    
      } else {
        columns.splice(5, 0, { field: "alvaras", label: "Vencimento Alvara" });
        columns.push({ field: "acoes", label: "Ações" });
      }
      return columns;
    },

    empresasAlvarasTaxas() {
      return this.empresasAlvaras.data;
    },

    pagination() {
      return this.empresasAlvaras.pagination;
    },
    tamanhoTela() {
      const tamanhoFixo = this.calcularTamanhoTabela();
      const larguraTela =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;
      const tamanhoRelativo = (tamanhoFixo / larguraTela) * 100;
      const tamanhoFinal = tamanhoRelativo;
      return `width:${tamanhoFinal}vw;`;
    },
  },
  watch: {
    "filtros.status_alvara"() {
      this.filtros.tipo_alvara = "alvara";
    },
    "filtros.perPage"() {
      this.fetchEmpresasAlvarasTaxa();
    },
    "filtros.tem_taxa_viabilidade"() {
      if (!this.filtros.sem_viabiliade_taxa_data_cadastrada) {
        this.fetchEmpresasAlvarasTaxa();
      } else if (this.filtros.tem_taxa_viabilidade == "0") {
        this.filtros.sem_viabiliade_taxa_data_cadastrada = null;
        this.fetchEmpresasAlvarasTaxa();
      }
    },
    "filtros.sem_viabiliade_taxa_data_cadastrada"() {
      if (this.filtros.sem_viabiliade_taxa_data_cadastrada) {
        this.filtros.tem_taxa_viabilidade = 1;
      }
      this.fetchEmpresasAlvarasTaxa();
    },
    current_page() {
      this.filtros.page = this.current_page;
      this.fetchEmpresasAlvarasTaxa();
    },
    searchQuery: _.debounce(function () {
      if (this.searchQuery.length > 3) {
        this.searchCidades();
      }
    }, 400),
  },
  methods: {
    hasRole,
    getTagType(status) {
      switch (status) {
        case 1:
          return "is-success";
        case 2:
          return "is-danger";
        default:
          return "is-dark";
      }
    },
    filtragens(data) {
      let b, c;
      const today = new Date();
      const vencimento = new Date(data.data_vencimento);
      const diffDays = Math.ceil((vencimento - today) / (1000 * 60 * 60 * 24));

      switch (this.status_alvara) {
        case "prox_venc":
          b = diffDays > 0 && diffDays <= 45 ? true : false;
          break;
        case "vencido":
          b = diffDays <= 0 ? true : false;
          break;
        case "normal":
          b = diffDays > 45 ? true : false;
          break;
        case "definitivo":
          b =
            data.tipo_document == "alvara"
              ? !data.definitivo
                ? false
                : true
              : false;

          break;

        default:
          b = false;
          break;
      }

      return b;
    },
    filtragens2(value) {
      let b;

      let result = value.filter((data) => {
        const today = new Date();
        const vencimento = new Date(data.data_vencimento);
        const diffDays = Math.ceil(
          (vencimento - today) / (1000 * 60 * 60 * 24)
        );
        switch (this.status_taxa) {
          case "prox_venc":
            b = diffDays > 0 && diffDays <= 45 ? true : false;
            break;
          case "vencido":
            b = diffDays <= 0 ? true : false;
            break;
          case "normal":
            b = diffDays > 45 ? true : false;
            break;

          default:
            b = false;
            break;
        }
        return b;
      });

      return result.length > 0 ? true : false;
    },
    getStatus(value) {
      const today = new Date();
      const vencimento = new Date(value.data_vencimento);
      const diffDays = Math.ceil((vencimento - today) / (1000 * 60 * 60 * 24));
      if (
        !value.tipo_document
          ? false
          : value.tipo_document == "alvara"
          ? !value.definitivo
            ? false
            : true
          : false
      ) {
        return "Definitivo";
      }

      if (diffDays <= 0) {
        return "Venc";
      } else if (diffDays <= 40) {
        return "Próx Venc";
      } else {
        return "Normal";
      }
    },
    getStatusClass(taxa) {
      const status = this.getStatus(taxa);

      return status === "Venc"
        ? "bg-error-base text-neutral-100 pl-1 mt-1 rounded"
        : status === "Próx Venc"
        ? "bg-warning-base text-neutral-100 pl-1 mt-1 rounded"
        : status === "Normal"
        ? "bg-success-base text-neutral-100 pl-1 mt-1 rounded"
        : "bg-primary-600 text-neutral-100 pl-1 mt-1 rounded";
    },

    hasNoAlvaras(row) {
      return (
        !row.alvara && !row.ambiental && !row.bombeiro && !row.alvara_sanitario
      );
    },
    hasNoTaxas(row) {
      let contadoTaxas = 0;

      row.taxas.map((taxa) => {
        if (taxa.envio == null) {
          contadoTaxas++;
        }
      });
      return !(contadoTaxas > 0);
    },
    async fetchEmpresaAlvaraTaxasVencidas() {
      if (!this.buscouVencidas) {
        const today = new Date();
        const firstDayOfMonth = new Date(
          today.getFullYear(),
          today.getMonth(),
          1
        );
        const lastDayOfMonth = new Date(
          today.getFullYear(),
          today.getMonth() + 1,
          0
        );
        this.filtros.data = [firstDayOfMonth, lastDayOfMonth];
        this.filtros.status_taxa = "vencido";
      } else {
        this.filtros.data = [];
        this.filtros.status_taxa = null;
      }

      await this.fetchEmpresasAlvarasTaxa();
      this.buscouVencidas = !this.buscouVencidas;
    },

    async fetchEmpresasAlvarasTaxa() {
      this.loading = true;
      if (this.empresas_id) {
        this.filtros.empresas_id = this.empresas_id.split(",");
      } else {
        this.filtros.empresas_id = null;
      }
      this.filtros.tipo_planilha = this.tipo_planilha ? 1 : 0;
      const { filtros } = this;
      await indexEmpresasAlvarasRequest(filtros)
        .then((res) => (this.empresasAlvaras = res.data))
        .finally(() => (this.loading = false));
    },
    openCreateModal() {
      this.createModal = true;
    },
    openEditModal(currentEmpAlvs) {
      this.$store.dispatch("setEmpresa", currentEmpAlvs);
      this.currentEmpAlvs = currentEmpAlvs;
      this.editModal = true;
    },
    onEditTaxa() {
      this.fetchEmpresasAlvarasTaxa();
      this.editModal = false;
    },
    onCreateTaxa() {
      this.fetchEmpresasAlvarasTaxa();
      this.createModal = false;
    },

    onPageChange(page) {
      this.current_page = page;
    },

    gerarRelatorio(t) {
      // Mapeia datas para o formato ISO
      let form = {
        data:
          this.filtros.data != null
            ? this.filtros.data.map((date) => date.toISOString())
            : null,
        tipo_alvara: this.filtros.tipo_alvara,
      };
      console.log(form);

      // Constrói a string de parâmetros, tratando corretamente arrays
      const parametrosString = Object.entries(form)
        .flatMap(([chave, valor]) => {
          if (Array.isArray(valor)) {
            return valor.map(
              (item) =>
                `${encodeURIComponent(chave)}[]=${encodeURIComponent(item)}`
            );
          } else {
            return `${encodeURIComponent(chave)}=${encodeURIComponent(valor)}`;
          }
        })
        .join("&");

      // Define a base URL de acordo com o tipo
      const baseUrl =
        t === "taxa"
          ? `${process.env.VUE_APP_API_URL}/empresas/alvarastaxas/relatorio`
          : `${process.env.VUE_APP_API_URL}/empresas/tipoalvaras/relatorio`;

      // Monta a URL completa incluindo o token e abre em uma nova aba
      const urlCompleta = `${baseUrl}?${parametrosString}&token=${this.getToken}`;
      window.open(urlCompleta, "_blank");

      // Antigo código comentado que talvez fosse uma alternativa via Vuex
      // const action = t === "taxa"
      //   ? "empresas/gerarRelatorioTaxa"
      //   : "empresas/gerarRelatorioAlvara";
      // this.$store.dispatch(action, this.form);
    },

    editarTaxa(empresa_id) {
      this.$router.push({
        name: "empresas.taxa.edit",
        params: { empresa_id: empresa_id },
      });
    },

    calcularTamanhoTabela() {
      let totalWidth = 0;
      this.colunas.map((column) => {
        switch (column.field) {
          case "id":
            totalWidth += 80;
            break;

          case "razao_social":
            totalWidth += 300;
            break;

          default:
            totalWidth += 200;
            break;
        }
      });
      totalWidth += 100;

      return totalWidth;
    },
    async fetchCarteiras() {
      this.getUsers();
      await this.$store.dispatch("carteira/listar_carteiras");
    },
    getUsers() {
      usersRequest().then(({ data: { data } }) => {
        let arrayNew = [];

        for (let i = 0; i < data.length; i++) {
          if (data[i].deleted_at == null) {
            arrayNew.push({ id: data[i].id, label: data[i].nome_completo });
          }
        }

        this.lista_usuarios = arrayNew;
      });
    },
    clearSearchQuery() {
      this.searchQuery = "";
    },
    searchCidades() {
      this.loadingCidades = true;

      showCidadesRequest(this.searchQuery)
        .then((res) => {
          this.lista_cidades = res.data.map((item) => {
            return {
              id: item.id,
              nome: item.nome + "-" + item.estado.uf,
            };
          });
        })
        .finally(() => (this.loadingCidades = false));
    },

    transitionName() {
      if (this.useTransition) {
        return "fade";
      }
    },
    fecharTodos(row, index) {
      this.defaultOpenedDetails = [row.id];
    },
    async criarCheckAlvaraTaxa() {
      this.loading = true;
      await criarCheckAlvaraTaxaRequest(this.formCheck.empresa_id, {
        motivo: this.formCheck.motivo,
      })
        .then((response) => {
          this.$snack.success(response.data.msg);
        })
        .catch((err) =>
          this.$snack.error(err.response.data.message || this.errorMessage)
        )
        .finally(() => {
          this.modalCheckAlvaraTaxa = false;
          this.loading = false;
          this.fetchEmpresasAlvarasTaxa();
        });
    },
    showModalCheckAlvaraTaxa(empresa) {
      this.formCheck.empresa_id = empresa.id;
      this.checkAlvaraTaxa = empresa.check_alvara_taxa;
      if (empresa.check_alvara_taxa != null) {
        this.formCheck.motivo = empresa.check_alvara_taxa.motivo;
      } else {
        this.formCheck.motivo = null;
        this.checkAlvaraTaxa = null;
      }
      this.modalCheckAlvaraTaxa = true;
    },
    hideModalCheckAlvaraTaxa() {
      this.modalCheckAlvaraTaxa = false;
    },
    showModalViabilidade(empresa) {
      if (empresa.viabilidade.taxas) {
        this.taxas = Object.keys(empresa.viabilidade.taxas).map((taxa) => taxa);
        this.viabilidade = empresa.viabilidade;
      }

      this.modalViabilidade = true;
    },
    getColorViabilidade(empresa) {
      if (this.hasNoTaxas(empresa)) {
        return "error";
      }
      const viabilidade = empresa.viabilidade;

      if (empresa.taxas != null) {
        let taxas = empresa.taxas;
        let taxasAgrupadas = {};

        taxas.forEach((taxa) => {
          if (!taxasAgrupadas[taxa.type_document]) {
            taxasAgrupadas[taxa.type_document] = [];
          }
          taxasAgrupadas[taxa.type_document].push(taxa);
        });

        for (var tipo in taxasAgrupadas) {
          let ultimaTaxa =
            taxasAgrupadas[tipo][taxasAgrupadas[tipo].length - 1];
          if (!viabilidade.taxas.hasOwnProperty(tipo)) {
            return "danger";
          }
          let format =
            viabilidade.taxas[tipo].tipo_cobranca === "mensal"
              ? "DD/MM"
              : "DD/MM/YYYY";

          if (
            moment(ultimaTaxa.data_vencimento).format(format) !==
            moment(viabilidade.taxas[tipo].valor).format(format)
          ) {
            return "warning";
          }
        }

        return "success";
      }

      return "danger";
    },
  },

  beforeMount() {
    this.fetchEmpresasAlvarasTaxa();
    this.fetchCarteiras();
  },
};
</script>


  
